import * as React from 'react';
import { SVGProps } from 'react';

interface CreditCardLogosProps extends SVGProps<SVGSVGElement> {
  showSVG: {
    showAMEX: boolean;
    showMastercard: boolean;
    showVISA: boolean;
    showDiscover: boolean;
    background: {
      color: string;
      isInherit: boolean;
    };
  };
  svgWidth: string;
  svgHeight: string;
}
const CreditCardLogos: React.FC<CreditCardLogosProps> = ({
  showSVG = {
    showAMEX: true,
    showMastercard: true,
    showVISA: true,
    showDiscover: true,
    background: {
      color: '#FFFFFF',
      isInherit: false,
    },
  },
  svgWidth = '35',
  svgHeight = '28',
}) => {
  return (
    <>
      <div
        className="flex gap-0 p-0 m-0 leading-none h-8"
        style={{
          backgroundColor: showSVG?.background?.isInherit
            ? 'inherit'
            : showSVG?.background?.color,
        }}>
        {showSVG.showAMEX && (
          <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 46 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M32.8755 20.084L31.801 18.9236L30.7265 20.084H24.1076V14.7116H21.9586L24.6233 8.65138H27.2021L28.1477 10.7144V8.65138H31.3282L31.8869 10.2416L32.4457 8.65138H34.8955V7.70582C34.8955 7.14708 34.4227 6.71729 33.907 6.71729H12.417C11.8583 6.71729 11.4285 7.19006 11.4285 7.70582V20.7287C11.4285 21.2875 11.9012 21.7173 12.417 21.7173H33.907C34.4657 21.7173 34.8955 21.2445 34.8955 20.7287V20.084H32.8755Z"
              fill="#0071CE"
            />
            <path
              d="M33.1764 19.4822H34.8956L32.6607 17.1184L34.8956 14.7545H33.2194L31.8441 16.2588L30.4687 14.7545H28.7925L31.0274 17.1184L28.7925 19.4822H30.4257L31.8011 17.978L33.1764 19.4822Z"
              fill="#0071CE"
            />
            <path
              d="M26.0846 18.4077V17.6771H28.7493V16.6026H26.0846V15.8289H28.7923V14.7545H24.7952V19.4822H28.7923V18.4077H26.0846ZM33.6061 14.1098H34.8525V9.38196H32.9184L31.8439 12.3046L30.8124 9.38196H28.7923V14.1098H30.0817V10.8003L31.2851 14.1098H32.4026L33.6061 10.8003V14.1098Z"
              fill="#0071CE"
            />
            <path
              d="M26.7295 9.38196H25.0962L23.0332 14.0668H24.4515L24.8384 13.1212H26.9874L27.3742 14.0668H28.8355L26.7295 9.38196ZM25.2252 12.0897L25.8699 10.5424L26.5146 12.0897H25.2252ZM33.6922 16.9894L34.8957 18.2788V15.7L33.6922 16.9894Z"
              fill="#0071CE"
            />
          </svg>
        )}
        {showSVG.showMastercard && (
          <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 45 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19.3828 8.09918H26.5896V19.9009H19.3828V8.09918Z"
              fill="#FF5F00"
            />
            <path
              d="M20.1085 14C20.1085 11.6783 21.1726 9.50178 22.9622 8.09911C19.7216 5.53561 14.9815 6.11603 12.418 9.35667C9.85452 12.5973 10.4349 17.3374 13.6756 19.9009C16.3842 22.0291 20.2052 22.0291 22.9622 19.9009C21.1726 18.4498 20.1085 16.2733 20.1085 14Z"
              fill="#EB001B"
            />
            <path
              d="M34.4253 18.6433V18.4015H34.5221V18.3531H34.2802V18.4015H34.377L34.4253 18.6433ZM34.909 18.6433V18.3531H34.8123L34.7155 18.5466L34.6188 18.3531H34.5221V18.6433H34.5704V18.4015L34.6672 18.5949H34.7155L34.8123 18.4015V18.6433H34.909ZM35.1025 14C35.1025 18.1596 31.7651 21.497 27.6055 21.497C25.9126 21.497 24.2681 20.9166 22.9622 19.9009C26.2028 17.3374 26.7832 12.6457 24.2197 9.35667C23.8328 8.87299 23.4458 8.48605 22.9622 8.09911C26.2028 5.53561 30.9429 6.11603 33.5064 9.35667C34.5704 10.6626 35.1025 12.3071 35.1025 14Z"
              fill="#F79E1B"
            />
          </svg>
        )}
        {showSVG.showVISA && (
          <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 45 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6809 6.5H34.2642V21.5H10.6809V6.5Z" fill="white" />
            <path
              d="M11.0974 19.0417H33.8891V21.0834H11.0974V19.0417Z"
              fill="#FCB316"
            />
            <path
              d="M11.0974 6.91669H33.8891V8.95835H11.0974V6.91669ZM20.2224 11.2084L17.8474 16.8334H16.3057L15.1391 12.3334C15.1391 12.125 14.9724 11.9167 14.8057 11.8334C14.3474 11.625 13.8474 11.4584 13.3891 11.375L13.4307 11.2084H15.8891C16.2224 11.2084 16.5141 11.4584 16.5557 11.7917L17.1807 15.0417L18.6808 11.2084H20.2224ZM26.2224 15C26.2224 13.5 24.1808 13.4167 24.1808 12.7917C24.1808 12.5834 24.3891 12.375 24.8058 12.3334C25.3058 12.2917 25.8057 12.375 26.2224 12.5834L26.4724 11.375C26.0558 11.2084 25.5557 11.125 25.0974 11.125C23.6807 11.125 22.6391 11.875 22.6391 13C22.6391 13.7917 23.3474 14.25 23.9307 14.5417C24.5141 14.8334 24.6807 15 24.6807 15.25C24.6807 15.625 24.2224 15.7917 23.8057 15.7917C23.3057 15.7917 22.7641 15.6667 22.3058 15.4584L22.0557 16.7084C22.5557 16.9167 23.1391 17 23.6808 17C25.2224 16.9167 26.2224 16.1667 26.2224 15ZM30.0557 16.8334H31.3891L30.2224 11.2084H28.9724C28.6808 11.2084 28.4724 11.375 28.3474 11.625L26.1808 16.8334H27.7224L28.0141 16H29.8891L30.0557 16.8334ZM28.4308 14.8334L29.1808 12.7084L29.6391 14.8334H28.4308ZM22.3058 11.2084L21.0974 16.8334H19.6391L20.8474 11.2084H22.3058Z"
              fill="#10357F"
            />
          </svg>
        )}
        {showSVG.showDiscover && (
          <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 39 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M31.2708 15.3143C31.2708 15.3143 24.9279 19.8143 13.2708 21.8286H31.2708V15.3143Z"
              fill="#EF7622"
            />
            <path
              d="M31.3572 7H8V22H31.4429V7H31.3572ZM31.2714 7.17143V21.8286H8.17143V7.17143H31.2714Z"
              fill="#231F20"
            />
            <path
              d="M10.0568 11.5857H9.07104V14.9714H10.0139C10.4425 15.0143 10.9139 14.8428 11.2568 14.5857C11.6425 14.2857 11.8568 13.8143 11.8568 13.3C11.8568 12.3571 11.1282 11.5857 10.2282 11.5857H10.0568ZM10.8282 14.1571C10.571 14.3714 10.2282 14.4571 9.92819 14.4143H9.75676V12.1428H9.92819C10.271 12.1 10.571 12.2285 10.8282 12.4C11.0853 12.6143 11.2139 12.9143 11.2139 13.2571C11.2139 13.6428 11.0853 13.9428 10.8282 14.1571ZM12.1568 11.5857H12.7996V14.9714H12.1568V11.5857ZM14.4282 12.8714C14.0425 12.7428 13.9139 12.6143 13.9139 12.4428C13.9139 12.2714 14.1282 12.0571 14.3853 12.0571C14.5996 12.0571 14.771 12.1428 14.8996 12.3143L15.2425 11.8428C14.9853 11.5857 14.5996 11.4571 14.2568 11.4571C13.6996 11.4143 13.2282 11.8428 13.1853 12.4V12.4428C13.1853 12.9143 13.3996 13.1714 13.9996 13.3857C14.171 13.4285 14.2996 13.5143 14.471 13.6C14.5996 13.6857 14.6853 13.8143 14.6853 13.9428C14.6853 14.2 14.471 14.4143 14.2139 14.4143H14.171C13.871 14.4143 13.571 14.2428 13.4425 13.9428L13.0139 14.3714C13.271 14.8 13.6996 15.0143 14.2139 15.0143C14.8139 15.0571 15.3282 14.5857 15.371 13.9857V13.9C15.4139 13.4285 15.1996 13.1714 14.4282 12.8714ZM15.6282 13.3C15.6282 14.2857 16.3996 15.0571 17.3853 15.0571H17.4282C17.7282 15.0571 17.9853 14.9714 18.2425 14.8428V14.0714C18.0282 14.2857 17.771 14.4571 17.4282 14.4571C16.8282 14.4571 16.3139 13.9857 16.271 13.3857V13.3C16.271 12.6571 16.7425 12.1428 17.3425 12.1428H17.3853C17.6853 12.1428 18.0282 12.2714 18.1996 12.5285V11.7143C17.9425 11.5857 17.6853 11.5 17.3853 11.5C16.4425 11.5 15.6282 12.2714 15.6282 13.3ZM23.5139 13.8571L22.6139 11.5857H21.8853L23.2996 15.0571H23.6853L25.1425 11.5857H24.4139L23.5139 13.8571ZM25.4425 14.9714H27.3282V14.4143H26.0853V13.5143H27.2853V12.9143H26.0853V12.1857H27.3282V11.5857H25.4425V14.9714ZM29.9425 12.5714C29.9425 11.9285 29.5139 11.5857 28.7425 11.5857H27.7568V14.9714H28.3996V13.6H28.4853L29.3853 14.9714H30.1996L29.1282 13.5571C29.6425 13.4714 29.9853 13.0857 29.9425 12.5714ZM28.6139 13.1714H28.3996V12.1428H28.6139C29.0425 12.1428 29.2568 12.3143 29.2568 12.6571C29.2568 13 29.0425 13.1714 28.6139 13.1714ZM30.4139 11.7571C30.4139 11.7143 30.3711 11.6714 30.2853 11.6714H30.1996V11.9714H30.2853V11.8428L30.371 11.9714H30.4568L30.371 11.8428C30.371 11.8428 30.4139 11.8 30.4139 11.7571ZM30.2853 11.8V11.7143C30.3282 11.7143 30.3282 11.7143 30.3282 11.7571C30.3282 11.8 30.3282 11.8 30.2853 11.8Z"
              fill="#231F20"
            />
            <path
              d="M30.2857 11.5428C30.1571 11.5428 30.0286 11.6714 30.0286 11.8C30.0286 11.9286 30.1571 12.0571 30.2857 12.0571C30.4143 12.0571 30.5428 11.9286 30.5428 11.8C30.5428 11.6714 30.4571 11.5428 30.2857 11.5428ZM30.2857 12.0143C30.1571 12.0143 30.0714 11.9286 30.0714 11.8C30.0714 11.6714 30.1571 11.5857 30.2857 11.5857C30.4143 11.5857 30.5 11.6714 30.5 11.8C30.5 11.9286 30.4143 12.0143 30.2857 12.0143Z"
              fill="#231F20"
            />
            <mask
              id="mask0_8_65"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="18"
              y="11"
              width="5"
              height="5">
              <path
                d="M18.5002 13.3428C18.5002 14.3286 19.3145 15.1428 20.3002 15.1428C21.286 15.1428 22.1002 14.3286 22.1002 13.3428C22.1002 12.3571 21.286 11.5428 20.3002 11.5428C19.2717 11.5428 18.5002 12.3571 18.5002 13.3428Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_8_65)">
              <path
                d="M23.6856 14.0714L21.0285 9.91425L16.8713 12.5714L19.5285 16.7285L23.6856 14.0714Z"
                fill="url(#paint0_linear_8_65)"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_8_65"
                x1="21.1819"
                y1="14.7663"
                x2="19.9432"
                y2="12.8269"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F59F00" />
                <stop offset="0.234" stopColor="#F49A01" />
                <stop offset="0.499" stopColor="#F28D04" />
                <stop offset="0.62" stopColor="#F18406" />
                <stop offset="0.755" stopColor="#EF7B09" />
                <stop offset="1" stopColor="#ED6F0D" />
              </linearGradient>
            </defs>
          </svg>
        )}
      </div>
    </>
  );
};
export default CreditCardLogos;
